<template>
  <div id="slidebar" :class="{ 'has-logo': showLogo }">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <!-- <div style="text-align: center; margin: 5px 10px">
      <el-input v-model="word" placeholder="搜索功能板块" @input="search" />
    </div> -->
    <div
      v-if="list.length != 0"
      style="font-size: 14px; background: #fff; margin: 0 10px"
    >
      <div
        v-for="(item, i) in list"
        :key="i"
        style="
          line-height: 35px;
          margin-left: 10px;
          cursor: pointer;
          font-weight: bold;
          text-align: center;
        "
        @click="navigatoPath(item)"
      >
        {{ item.meta.title }}
      </div>
    </div>
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-openeds="openeds"
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="true"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item
          v-for="route in permission_routes"
          :key="route.path"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Logo from './Logo'
import SidebarItem from './SidebarItem'
import variables from '@/styles/variables.scss'

export default {
  components: { SidebarItem, Logo },
  data() {
    return {
      openeds: [],
      search_routes: [],
      result: [],
      word: '',
      list: [] // 搜索出来的板块
    }
  },
  computed: {
    ...mapGetters(['permission_routes', 'sidebar']),
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    showLogo() {
      // return this.$store.state.settings.sidebarLogo
      return true
    },
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  mounted() {
    this.permission_routes.forEach((item) => {
      if (item.children && item.children.length != 0) {
        this.search_routes.push(item)
      }
    })
    // console.log(this.search_routes);
    this.search_routes.forEach((item) => {
      if (item.children.length == 0) {
        this.result.push(item)
      } else {
        item.children.forEach((subitem) => {
          if (subitem.hidden) return
          else {
            this.result.push(subitem)
          }
        })
      }
    })
    // console.log("this.result", this.result);
  },
  methods: {
    // 搜索板块
    search() {
      if (this.word == '') {
        this.list = []
        return
      }
      this.list = this.result.filter((item) => {
        return item.meta.title.includes(this.word)
      })
      // console.log("搜索出来的板块", this.list);
    },
    // 从搜索结果中跳转
    navigatoPath(item) {
      this.$router.push(item.path)
      this.word = ''
      this.list = []
    }
  }
}
</script>
<style lang="scss">
#slidebar {
  .el-input--mini .el-input__inner {
    line-height: 33px;
    background: #212f3d;
    border: 1px solid #212f3d;
    color: #ffffff;
    height: 33px;
    font-size: 14px;
    text-align: center;
    font-weight: bold;
  }
}
</style>
